/**
 * @generated SignedSource<<6dc6e9bc05fd753786bf4d9e8118bb4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type OrderStatus = "abandoned" | "advance" | "canceled" | "draft" | "paid" | "pending" | "trash";
export type UpdateOrderInput = {
  adminComment?: string | null;
  id: string;
  status?: OrderStatus | null;
};
export type OrderEditMainFormMutation$variables = {
  order: UpdateOrderInput;
};
export type OrderEditMainFormMutation$data = {
  readonly updateOrder: {
    readonly id: string;
  };
};
export type OrderEditMainFormMutation = {
  response: OrderEditMainFormMutation$data;
  variables: OrderEditMainFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "order"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "order",
        "variableName": "order"
      }
    ],
    "concreteType": "Order",
    "kind": "LinkedField",
    "name": "updateOrder",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OrderEditMainFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OrderEditMainFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "cdb2a16d933733e44eaa750db1b94cee",
    "id": null,
    "metadata": {},
    "name": "OrderEditMainFormMutation",
    "operationKind": "mutation",
    "text": "mutation OrderEditMainFormMutation(\n  $order: UpdateOrderInput!\n) {\n  updateOrder(order: $order) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "89c4dca1a081761ee95cf10016eea68b";

export default node;
